var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisgust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7113 21.9713L16 9.115V2H17C17.2652 2 17.5196 1.89464 17.7071 1.70711C17.8947 1.51957 18 1.26522 18 1C18 0.734784 17.8947 0.48043 17.7071 0.292893C17.5196 0.105357 17.2652 0 17 0H7.00003C6.73481 0 6.48046 0.105357 6.29292 0.292893C6.10538 0.48043 6.00003 0.734784 6.00003 1C6.00003 1.26522 6.10538 1.51957 6.29292 1.70711C6.48046 1.89464 6.73481 2 7.00003 2H8.00003V9.115L0.288778 21.9713C0.106908 22.2745 0.00867024 22.6205 0.0040752 22.974C-0.000519849 23.3276 0.088692 23.676 0.26262 23.9838C0.436548 24.2917 0.688975 24.5479 0.994179 24.7264C1.29938 24.9049 1.64646 24.9993 2.00003 25H22C22.3539 25 22.7015 24.9061 23.0072 24.7278C23.3129 24.5496 23.5659 24.2934 23.7403 23.9855C23.9146 23.6775 24.0042 23.3288 23.9997 22.9749C23.9953 22.6211 23.8971 22.2747 23.715 21.9713H23.7113ZM12.4513 16.6075C10.4625 15.6012 8.57003 15.0675 6.79878 15.0063L9.85753 9.90625C9.95105 9.75123 10.0003 9.57355 10 9.3925V2H14V9.3925C13.9997 9.57355 14.049 9.75123 14.1425 9.90625L18.92 17.875C17.425 18.1675 15.2863 18.0425 12.4513 16.6075Z",
    fill: "url(#paint0_linear_668_21023)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_21023",
    x1: 23.9999,
    y1: 7.45058e-7,
    x2: -5.19964,
    y2: 14.5757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1D860"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisgust);
export default __webpack_public_path__ + "static/media/Disgust.7f6c194cbe6be519784444e5133fb227.svg";
export { ForwardRef as ReactComponent };